import { render, staticRenderFns } from "./OldTimeTableCalendar.vue?vue&type=template&id=dec5b20e&"
import script from "./OldTimeTableCalendar.vue?vue&type=script&lang=js&"
export * from "./OldTimeTableCalendar.vue?vue&type=script&lang=js&"
import style0 from "./OldTimeTableCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports